<template>
  <div class="fy_index_title">
    <div v-for="title in titleList">
      <h2>{{title[0]}}</h2>
      <h4>{{title[1]}}</h4>
    </div>
  </div>
</template>

<script>
    import './../assets/css/fy_index_title.css'
    export default {
        name: "fy_index_title",
        data() {
            return {
                titleList: [
                    ['永久免费','云收银，永久免费接入'],
                    ['免费软件','餐饮云、零售云、扫码购'],
                    ['官方收款','微信支付、支付宝官方'],
                ]
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_index_title.vue